module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("资源位配置")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    model: {
      value: (_vm.paramData),
      callback: function($$v) {
        _vm.paramData = $$v
      },
      expression: "paramData"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.paramData.status),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "status", $$v)
      },
      expression: "paramData.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已发布",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未发布",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已撤销",
      "value": 9
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "位置类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择位置类型"
    },
    model: {
      value: (_vm.paramData.positionType),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "positionType", $$v)
      },
      expression: "paramData.positionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部位置",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "进展banner",
      "value": 9
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页活动信息栏",
      "value": 13
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页宣传栏",
      "value": 14
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我的banner",
      "value": 15
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "排行榜banner",
      "value": 19
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支付宝小程序首页banner",
      "value": 21
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支付宝小程序我的banner",
      "value": 22
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "广场推荐banner",
      "value": 23
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本之前的发现频道",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跑步结束banner",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动音乐顶部",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页-为你推荐",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "社区-动态",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本及之后的发现频道",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "问卷调查",
      "value": 7
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动banner",
      "value": 8
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片1",
      "value": 10
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片2",
      "value": 11
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页瓷片3",
      "value": 12
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页摩西",
      "value": 20
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序顶部banner轮播",
      "value": 16
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序banner",
      "value": 17
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小程序底部banner列表",
      "value": 18
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.daterange),
      callback: function($$v) {
        _vm.daterange = $$v
      },
      expression: "daterange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索名称关键字"
    },
    model: {
      value: (_vm.paramData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "keyWord", $$v)
      },
      expression: "paramData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddition
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickBatchPublish
    }
  }, [_vm._v("批量发布")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickBatchRevoke
    }
  }, [_vm._v("批量撤销")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickBatchDelete
    }
  }, [_vm._v("批量删除")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData
    },
    on: {
      "selection-change": _vm.selectionChanged
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "ID",
      "prop": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.positionType === 9) ? _c('div', [_vm._v("进展BANNER")]) : _vm._e(), _vm._v(" "), (row.positionType === 13) ? _c('div', [_vm._v("首页活动信息栏")]) : _vm._e(), _vm._v(" "), (row.positionType === 14) ? _c('div', [_vm._v("首页宣传栏")]) : _vm._e(), _vm._v(" "), (row.positionType === 15) ? _c('div', [_vm._v("我的-轮播位")]) : _vm._e(), _vm._v(" "), (row.positionType === 19) ? _c('div', [_vm._v("排行榜banner")]) : _vm._e(), _vm._v(" "), (row.positionType === 21) ? _c('div', [_vm._v("支付宝小程序首页banner")]) : _vm._e(), _vm._v(" "), (row.positionType === 22) ? _c('div', [_vm._v("支付宝小程序我的banner")]) : _vm._e(), _vm._v(" "), (row.positionType === 23) ? _c('div', [_vm._v("社区推荐页顶部")]) : _vm._e(), _vm._v(" "), (row.positionType === 1) ? _c('div', [_vm._v("3.0.0版本之前的发现频道")]) : _vm._e(), _vm._v(" "), (row.positionType === 2) ? _c('div', [_vm._v("跑步记录顶部")]) : _vm._e(), _vm._v(" "), (row.positionType === 3) ? _c('div', [_vm._v("运动音乐顶部")]) : _vm._e(), _vm._v(" "), (row.positionType === 4) ? _c('div', [_vm._v("首页-为你推荐")]) : _vm._e(), _vm._v(" "), (row.positionType === 5) ? _c('div', [_vm._v("社区-动态")]) : _vm._e(), _vm._v(" "), (row.positionType === 6) ? _c('div', [_vm._v("3.0.0版本及之后的发现频道")]) : _vm._e(), _vm._v(" "), (row.positionType === 7) ? _c('div', [_vm._v("问卷调查")]) : _vm._e(), _vm._v(" "), (row.positionType === 8) ? _c('div', [_vm._v("运动banner")]) : _vm._e(), _vm._v(" "), (row.positionType === 10) ? _c('div', [_vm._v("首页瓷片1")]) : _vm._e(), _vm._v(" "), (row.positionType === 11) ? _c('div', [_vm._v("首页瓷片2")]) : _vm._e(), _vm._v(" "), (row.positionType === 12) ? _c('div', [_vm._v("首页瓷片3")]) : _vm._e(), _vm._v(" "), (row.positionType === 20) ? _c('div', [_vm._v("首页摩西")]) : _vm._e(), _vm._v(" "), (row.positionType === 16) ? _c('div', [_vm._v("小程序顶部banner轮播")]) : _vm._e(), _vm._v(" "), (row.positionType === 17) ? _c('div', [_vm._v("小程序banner")]) : _vm._e(), _vm._v(" "), (row.positionType === 18) ? _c('div', [_vm._v("小程序底部banner列表")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "名称",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "图形",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "flex-row-center margin-bottom-10"
        }, [_c('img', {
          staticClass: "table-img",
          attrs: {
            "src": row.imgUrl,
            "alt": ""
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "适用学校"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(row.applicableCampus ? "部分" : "全部"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "点击量",
      "prop": "clickCount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.status === 1) ? _c('div', [_vm._v("草稿")]) : _vm._e(), _vm._v(" "), (row.status === 2) ? _c('div', [_vm._v("发布")]) : _vm._e(), _vm._v(" "), (row.status === 9) ? _c('div', [_vm._v("撤销发布")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "有效时间",
      "width": "320"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.beginAt && row.endAt) ? _c('div', [_vm._v("\n            " + _vm._s(new Date(row.beginAt).format("yyyy-MM-dd hh:mm:ss")) + " -\n            " + _vm._s(new Date(row.endAt).format("yyyy-MM-dd hh:mm:ss")) + "\n          ")]) : _c('div', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近操作时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.updatedTime) ? _c('div', [_vm._v("\n            " + _vm._s(new Date(row.updatedTime).format("yyyy-MM-dd hh:mm:ss")) + "\n          ")]) : _c('div', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "创建时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(row.creater))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss")) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [([1, 9].includes(row.status)) ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickPublish(row)
            }
          }
        }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(row)
            }
          }
        }, [_vm._v("删除")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDetail(row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickRevoke(row)
            }
          }
        }, [_vm._v("撤销")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.paramData.pageNum,
      "page-size": _vm.paramData.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fd83352!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/ResourceSpace/ResourceSpace.vue
// module id = 964
// module chunks = 0